<!-- 此处为处理项目经理以及总监得角色，涉及关联部门，苗场 -->
<template>
    <Modal
        v-model="showRoleEditModal"
        title="客户经理项目人角色"
        :mask-closable="false"
        width="800" 
    >
        <div class="table-container" style="max-height: 350px; overflow-y: auto; margin-bottom: 20px;">
            <stand-pagination-table
                :columns="mainTable.columns"
                :data="mainTable.data"
                :loading="mainTable.loading"
                :table-search="mainTable.tableSearch"
                :table-load-event="getRole"
                :totalSummaryFieldDatas="mainTable.sumData"
                :autoHeight = "true"
                :showPage="true"
            />
        </div>

        <Divider>编辑区域</Divider>

        <Form ref="columnForm" :model="form" :rules="formRules" :label-width="80">
            <FormItem label="角色名称" prop="name">
                <Input
                    v-model="form.name"
                    placeholder="请输入角色名称"
                />
            </FormItem>
            <FormItem label="状态" prop="recordStatus">
                <RadioGroup v-model="form.recordStatus" type="button">
                    <Radio v-for="item in statusOptions" :key="item.val" :label="item.val">{{ item.label }}</Radio>
                </RadioGroup>
            </FormItem>
        </Form>
        <div slot="footer">
            <Button @click="handleCancel">取消</Button>
            <Button type="primary" :loading="isSaving" @click="handleSave">
                保存
            </Button>
        </div>
    </Modal>
</template>

<script>
import { STATUS_YES, STATUS_NO, statusNewFormat } from '@/libs/baseModelFormat';
import search from "@/libs/search";
import SearchCard from '@/components/searchCard/searchCard.vue';
import StandPaginationTable from '@/components/pagination-table/pagination-table.vue';
import { getRoleList } from "@/api/modules/account-management/inspector-user-management";
import { dateRender } from '@/libs/tableRowTimeRender';
import { roleSave } from '@/api/modules/account-management/inspector-user-management';
import { FORM_EDIT_MODE_CREATE, FORM_EDIT_MODE_MODIFY } from '@/view/mixins/form-edit-mode';
export default {
    name: "RoleEditModal",
    components: {
        StandPaginationTable,
        SearchCard
    },
    data() {
        return {
            showRoleEditModal: false,
            isSaving: false,
            statusSource: [],
            type: '',
            
            // 表单数据模型
            form: {
                formEditMode: FORM_EDIT_MODE_CREATE,
                roleUuid: "",
                name: "",
                recordStatus: STATUS_YES,
                type: ""
            },
            
            formRules: {
                name: [
                    { required: true, message: '角色名称不能为空', trigger: 'blur' },
                    { max: 50, message: '角色名称不能超过50个字符', trigger: 'blur' }
                ]
            },
            
            // 主表格数据和配置
            mainTable: {
                columns: [
                    { title: "角色名称", key: "name", width: 300, align: 'center' },
                    {
                        title: '状态',
                        key: 'recordStatus',
                        align: 'center',
                        render: (h, params) => {
                            return h('div', [
                                h('span', {}, statusNewFormat(params.row.recordStatus))
                            ]);
                        }
                    },
                    {
                        title: '创建时间',
                        key: 'createTime',
                        align: 'center',
                        render: (h, params) => dateRender(h, params.row.createTime)
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 80,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                        shape: 'circle'
                                    },
                                    style: {},
                                    on: {
                                        click: () => {
                                            this.handleEdit(params.row);
                                        }
                                    }
                                }, '编辑')
                            ]);
                        }
                    }
                ],
                data: [],
                sumData: [],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    methods: {
        /**
         * @description 初始化状态选项
         */
        async init() {
            this.statusSource = [
                { val: STATUS_YES, label: statusNewFormat(STATUS_YES) },
                { val: STATUS_NO, label: statusNewFormat(STATUS_NO) }
            ];
        },

        /**
         * @description 打开模态框，并加载表格初始数据
         */
        openRoleEditModal(type) {
            this.showRoleEditModal = true;
            this.type=type;
            this.init();
            this.resetForm();
            this.getRole();
        },
        
        /**
         * @description 获取数据
         */
        async getRole() {
            this.mainTable.loading = true;
            try {
                this.mainTable.tableSearch.type = this.type;
                const res = await getRoleList(this.mainTable.tableSearch);
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    this.mainTable.sumData = res.data.sumRecord;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
                else {
                    this.$Message.error(res.msg || '获取角色列表失败');
                }
            }
            catch (error) {
                console.error("获取角色列表失败:", error);
                this.$Message.error('网络请求失败，请稍后重试');
            }
            finally {
                this.mainTable.loading = false;
            }
        },

        /**
         * @description 处理编辑操作，填充表单数据
         */
        handleEdit(row) {
            this.form = {
                formEditMode: FORM_EDIT_MODE_MODIFY,
                roleUuid: row.roleUuid || "",
                name: row.name || "",
                recordStatus: row.recordStatus || STATUS_YES,
                type: this.type
            };
        },

        /**
         * @description 处理保存操作
         */
        async handleSave() {
            const isValid = await this.$refs.columnForm.validate();
            if (!isValid) return;

            this.isSaving = true;
            try {
                const data = { ...this.form };
                const res = await roleSave(data);
                if (res.code === 0) {
                    this.$Message.success("保存成功");
                    this.resetForm();
                    await this.getRole();
                }
                else {
                    this.$Message.error(res.msg || '保存失败');
                }
            }
            catch (error) {
                console.error("保存角色失败:", error);
                this.$Message.error('网络请求失败，请稍后重试');
            }
            finally {
                this.isSaving = false;
            }
        },
        
        /**
         * @description 关闭并重置模态框
         */
        handleCancel() {
            this.showRoleEditModal = false;
            this.resetForm();
        },

        /**
         * @description 重置表单为空状态
         */
        resetForm() {
            this.form = { 
                formEditMode: FORM_EDIT_MODE_CREATE, 
                roleUuid: "", 
                name: "", 
                recordStatus: STATUS_YES,
                type: this.type
            };
            if (this.$refs.columnForm) {
                this.$refs.columnForm.resetFields();
            }
        }
    },
    computed: {
        statusOptions() {
            return [
                { val: STATUS_YES, label: statusNewFormat(STATUS_YES) },
                { val: STATUS_NO, label: statusNewFormat(STATUS_NO) }
            ];
        }
    }
};
    
</script>